export const carouselImages = [
    {
        "imagen" : "./image/infra01.jpg"
    },
    {
        "imagen" : "./image/infra02.jpg"
    },
    {
        "imagen" : "./image/infra03.jpg" 
    },
//     {
//         "imagen" : "https://cdn.hidalgo.gob.mx/gobierno/images/veda/banner_veda.png"
//     },
]